import { render, staticRenderFns } from "./ComplaintDetail.vue?vue&type=template&id=74765e58"
import script from "./ComplaintDetail.vue?vue&type=script&lang=js"
export * from "./ComplaintDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports